import React from 'react';
import get from 'lodash/get';
import { Controller, FieldError, useFormContext } from 'react-hook-form';
import { Row } from '../../../../CommonComponents/OPL/Grid/Row';
import { Column } from '../../../../CommonComponents/OPL/Grid/Column';
import { Input } from '../../../../CommonComponents/OPL/Input/Input';
import { Select } from '../../../../CommonComponents/OPL/Select/Select/Select';
import { yesNoOpts } from '../../AccountOpening.meta';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { MarginProps } from '../../../../theme/styledProps';
import { Grid } from '../../../../CommonComponents/OPL/Grid/Grid';
import { Wrapper } from '../../../../CommonComponents/OPL/Wrapper/Wrapper';

const fieldName = 'trustedContactInfo';

export const TrustedContact: React.FC<MarginProps> = props => {
  const formBag = useFormContext();
  const {
    formState: { errors },
  } = formBag;

  const hasTrustedContactField = `${fieldName}.hasTrustedContact`;
  const firstNameField = `${fieldName}.legalFirstName`;
  const lastNameField = `${fieldName}.legalLastName`;
  const emailField = `${fieldName}.email`;

  const hasTrustedContact = formBag.watch(hasTrustedContactField);

  return (
    <Wrapper {...props}>
      <Controller
        control={formBag.control}
        name={hasTrustedContactField}
        render={({ field }) => (
          <Select
            value={yesNoOpts.find(({ value }) => value === field.value)}
            label="Would you like to add a trusted contact?"
            onChange={opt => {
              if (opt) {
                formBag.setValue(hasTrustedContactField, opt.value);
              }
            }}
            options={yesNoOpts}
          />
        )}
      />

      {hasTrustedContact && (
        <Grid>
          <Row mt="8" mb="4">
            <Column width={12}>
              <Text variant="formLabel">Please provide the trusted contact information</Text>
            </Column>
          </Row>

          <Row>
            <Column width={4}>
              <Input
                {...formBag.register(firstNameField)}
                type="text"
                placeholder="First name"
                formVariant={get(errors, firstNameField) ? 'error' : undefined}
                helperText={(get(errors, firstNameField) as FieldError | undefined)?.message}
                autoComplete="given-name"
                aria-label="First name"
                maxLength={256}
              />
            </Column>

            <Column width={4}>
              <Input
                {...formBag.register(lastNameField)}
                type="text"
                placeholder="Last name"
                formVariant={get(errors, lastNameField) ? 'error' : undefined}
                helperText={(get(errors, lastNameField) as FieldError | undefined)?.message}
                autoComplete="family-name"
                aria-label="Last name"
                maxLength={256}
              />
            </Column>

            <Column width={4}>
              <Input
                {...formBag.register(emailField)}
                type="text"
                placeholder="Email"
                formVariant={get(errors, emailField) ? 'error' : undefined}
                helperText={(get(errors, emailField) as FieldError | undefined)?.message}
                autoComplete="email"
                aria-label="Email"
                maxLength={256}
              />
            </Column>
          </Row>
        </Grid>
      )}
    </Wrapper>
  );
};
